/**
 * OpenAI Service
 * Handles interactions with OpenAI/Azure OpenAI API for document parsing via backend
 */

import api from './api';

/**
 * Calls OpenAI or Azure OpenAI API to parse document text (via secure backend)
 * @param {string} documentText - The document text to parse
 * @param {string} systemMessage - The system message/prompt
 * @param {Object|null} responseFormat - The response format specification
 * @param {string} model - The model name (e.g., 'GPT 4.1', 'GPT 5-nano')
 * @param {number} temperature - Temperature value (0-1) for GPT 4.1
 * @param {string} reasoningEffort - Reasoning effort (low/medium/high) for GPT 5-nano
 * @param {boolean} enableChunking - Whether to chunk the document before parsing
 * @returns {Promise<Object>} Parsed data
 */
export async function parseDocumentWithOpenAI(documentText, systemMessage, responseFormat, model, temperature, reasoningEffort, enableChunking = false) {
  console.log('[INFO] Sending document to backend for OpenAI parsing with model:', model);

  const response = await api.post('/api/parse-document', {
      documentText,
      systemMessage,
      responseFormat,
      model,
      temperature,
      reasoningEffort,
      enableChunking,
      enable_chunking: enableChunking
    }, { timeout: 300000 }); // 5 min — reasoning models (DeepSeek, GPT 5-*) can be slow

  const parsedData = response.data;
  
  console.log('[INFO] Document parsing completed');
  
  return {
    data: parsedData.parsed_content,
    serverTimingMs: parsedData.server_timing_ms ?? null,
    usage: parsedData.usage ?? null,
    chunks: Array.isArray(parsedData.chunks) ? parsedData.chunks : [],
    chunking: parsedData.chunking ?? null,
  };
}
